<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper" ref="formContainer">
      <!-- Page Content -->
      <div class="content container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div
              class="welcome-box d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center">
                <div class="welcome-img">
                  <img
                    v-if="user?.avatar && user?.avatar != null"
                    :src="getEmployeeAvatar(user?.avatar)"
                    alt="User Image"
                    @error="handleImageError()"
                  />
                  <img
                    v-else
                    :src="require(`@/assets/img/profiles/${defaultAvatar}`)"
                    alt="User Image"
                  />
                </div>

                <div class="welcome-det">
                  <h3 class="mb-0">
                    Welcome, {{ user?.first_name }} {{ user?.last_name }}
                  </h3>
                  <small class="text-muted">{{ today }}</small>
                </div>
              </div>

              <div class="attendance-box text-end">
                <div
                  v-if="todayLabel.status"
                  class="status-badge"
                  :class="todayLabel.status.toLowerCase()"
                >
                  {{ todayLabel.status }}
                </div>
                <div class="status-badge leave" v-if="todayLabel.leave">
                  {{ todayLabel.leave }}
                </div>
                <div class="status-badge holiday" v-if="todayLabel.holiday">
                  {{ todayLabel.holiday }}
                </div>

                <div class="punch-time" v-if="punchInTime">
                  Punch In : <strong>{{ punchInTime }}</strong>
                </div>
                <div class="punch-time" v-if="punchOutTime">
                  Punch Out : <strong>{{ punchOutTime }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-8 col-md-8">
            <section class="dash-section">
              <h1 class="dash-sec-title">Today</h1>
              <div class="dash-sec-content">
                <div class="dash-info-list" v-if="updateData.today_leave">
                  <a href="javascript:;" class="dash-card text-danger">
                    <div class="dash-card-container">
                      <div class="dash-card-icon">
                        <i class="fa-regular fa-hourglass"></i>
                      </div>
                      <div class="dash-card-content">
                        <p>{{ updateData.today_leave }}</p>
                      </div>
                      <!-- <div class="dash-card-avatars">
                        <div class="e-avatar">
                          <img
                            src="@/assets/img/profiles/avatar-09.jpg"
                            alt="User Image"
                          />
                        </div>
                      </div> -->
                    </div>
                  </a>
                </div>

                <div class="dash-info-list" v-else>
                  <div class="dash-card">
                    <div class="dash-card-container">
                      <div class="dash-card-content no-data-content">
                        <div class="ant-empty-image">
                          <svg
                            width="64"
                            height="41"
                            viewBox="0 0 64 41"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              transform="translate(0 1)"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <ellipse
                                fill="#f5f5f5"
                                cx="32"
                                cy="33"
                                rx="32"
                                ry="7"
                              ></ellipse>
                              <g fill-rule="nonzero" stroke="#d9d9d9">
                                <path
                                  d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
                                ></path>
                                <path
                                  d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
                                  fill="#fafafa"
                                ></path>
                              </g>
                            </g>
                          </svg>
                        </div>
                        <p style="color: #00000040; margin-bottom: 0px">
                          No data
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section class="dash-section">
              <h1 class="dash-sec-title">Updates</h1>
              <div class="dash-sec-content">
                <div class="dash-info-list" v-if="updateData.coming_holiday">
                  <div class="dash-card">
                    <div class="dash-card-container">
                      <div class="dash-card-icon">
                        <i class="fa-solid fa-clipboard-list"></i>
                      </div>
                      <div class="dash-card-content">
                        <p>{{ updateData.coming_holiday }}</p>
                      </div>
                      <!-- <div class="dash-card-avatars">
                        <a href="javascript:;" class="e-avatar"
                          ><img
                            src="@/assets/img/profiles/avatar-05.jpg"
                            alt="User Image"
                        /></a>
                        <a href="javascript:;" class="e-avatar"
                          ><img
                            src="@/assets/img/profiles/avatar-07.jpg"
                            alt="User Image"
                        /></a>
                      </div> -->
                    </div>
                  </div>
                </div>
                <div class="dash-info-list" v-if="updateData.vacation_leave">
                  <div class="dash-card">
                    <div class="dash-card-container">
                      <div class="dash-card-icon">
                        <i class="fa-solid fa-clipboard-list"></i>
                      </div>
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#holiday_update_modal"
                      >
                        <div class="dash-card-content">
                          <p>{{ updateData.vacation_leave }}</p>
                        </div>
                      </a>
                      <!-- <div class="dash-card-avatars">
                        <a href="javascript:;" class="e-avatar"
                          ><img
                            src="@/assets/img/profiles/avatar-05.jpg"
                            alt="User Image"
                        /></a>
                        <a href="javascript:;" class="e-avatar"
                          ><img
                            src="@/assets/img/profiles/avatar-07.jpg"
                            alt="User Image"
                        /></a>
                      </div> -->
                    </div>
                  </div>
                </div>

                <div
                  class="dash-info-list"
                  v-if="
                    updateData.vacation_leave === '' &&
                    updateData.coming_holiday === ''
                  "
                >
                  <div class="dash-card">
                    <div class="dash-card-container">
                      <div class="dash-card-content no-data-content">
                        <div class="ant-empty-image">
                          <svg
                            width="64"
                            height="41"
                            viewBox="0 0 64 41"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              transform="translate(0 1)"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <ellipse
                                fill="#f5f5f5"
                                cx="32"
                                cy="33"
                                rx="32"
                                ry="7"
                              ></ellipse>
                              <g fill-rule="nonzero" stroke="#d9d9d9">
                                <path
                                  d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
                                ></path>
                                <path
                                  d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
                                  fill="#fafafa"
                                ></path>
                              </g>
                            </g>
                          </svg>
                        </div>
                        <p style="color: #00000040; margin-bottom: 0px">
                          No data
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section class="dash-section">
              <h1 class="dash-sec-title">Request</h1>
              <div class="dash-sec-content">
                <div
                  class="dash-info-list"
                  v-for="(request, index) in requestData"
                  :key="'request_' + index"
                >
                  <div class="dash-card">
                    <div class="dash-card-container">
                      <div class="dash-card-icon">
                        <i class="fa-solid fa-paper-plane"></i>
                      </div>
                      <router-link to="leaves-employee">
                        <div class="dash-card-content">
                          <p>{{ request }}</p>
                        </div>
                      </router-link>
                      <!-- <div class="dash-card-avatars">
                        <a href="javascript:;" class="e-avatar"
                          ><img
                            src="@/assets/img/profiles/avatar-08.jpg"
                            alt="User Image"
                        /></a>
                      </div> -->
                    </div>
                  </div>
                </div>

                <div class="dash-info-list" v-if="requestData.length === 0">
                  <div class="dash-card">
                    <div class="dash-card-container">
                      <div class="dash-card-content no-data-content">
                        <div class="ant-empty-image">
                          <svg
                            width="64"
                            height="41"
                            viewBox="0 0 64 41"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              transform="translate(0 1)"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <ellipse
                                fill="#f5f5f5"
                                cx="32"
                                cy="33"
                                rx="32"
                                ry="7"
                              ></ellipse>
                              <g fill-rule="nonzero" stroke="#d9d9d9">
                                <path
                                  d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
                                ></path>
                                <path
                                  d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
                                  fill="#fafafa"
                                ></path>
                              </g>
                            </g>
                          </svg>
                        </div>
                        <p style="color: #00000040; margin-bottom: 0px">
                          No data
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <div class="col-lg-4 col-md-4">
            <div class="dash-sidebar">
              <!-- <section>
                <h5 class="dash-title">Projects</h5>
                <div class="card">
                  <div class="card-body">
                    <div class="time-list">
                      <div class="dash-stats-list">
                        <h4>{{ tasks.total_task }}</h4>
                        <p>Total Tasks</p>
                      </div>
                      <div class="dash-stats-list">
                        <h4>{{ tasks.pending_task }}</h4>
                        <p>Pending Tasks</p>
                      </div>
                    </div>
                    <div class="request-btn">
                      <div class="dash-stats-list">
                        <h4>{{ projects.length }}</h4>
                        <p>Total Projects</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section> -->
              <section>
                <h5 class="dash-title">Your Leave</h5>
                <div class="card">
                  <div class="card-body">
                    <div class="time-list">
                      <div class="dash-stats-list">
                        <h4>{{ leaveCount }}</h4>
                        <p>Leave Taken</p>
                      </div>
                      <div class="dash-stats-list">
                        <h4>{{ remainLeaveCount }}</h4>
                        <p>Remaining</p>
                      </div>
                    </div>
                    <div class="request-btn">
                      <a
                        class="btn btn-primary"
                        href="javascript:;"
                        @click="redirectTo('leaves-employee')"
                        >Apply Leave</a
                      >
                    </div>
                  </div>
                </div>
              </section>
              <section>
                <h5 class="dash-title">Your time off allowance</h5>
                <div class="card">
                  <div class="card-body">
                    <div class="time-list">
                      <div class="dash-stats-list">
                        <h4>5.0 Hours</h4>
                        <p>Approved</p>
                      </div>
                      <div class="dash-stats-list">
                        <h4>15 Hours</h4>
                        <p>Remaining</p>
                      </div>
                    </div>
                    <!-- <div class="request-btn">
                      <a class="btn btn-primary" href="javascript:;"
                        >Apply Time Off</a
                      >
                    </div> -->
                  </div>
                </div>
              </section>
              <section>
                <h5 class="dash-title">Upcoming Vacation</h5>
                <div
                  class="card mb-1"
                  v-for="(holiday, index) in upcomingHolidays"
                  :key="'holidays_' + index"
                >
                  <div class="card-body text-center">
                    <h5 class="holiday-title mb-0">
                      {{ holiday?.name }} -
                      {{ getDateFromat(holiday?.holiday_date) }} To
                      {{ getDateFromat(holiday?.end_date) }}
                    </h5>
                  </div>
                </div>
                <div class="card mb-1" v-if="upcomingHolidays.length === 0">
                  <div class="card-body text-center">
                    <div class="ant-empty-image">
                      <svg
                        width="64"
                        height="41"
                        viewBox="0 0 64 41"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g
                          transform="translate(0 1)"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <ellipse
                            fill="#f5f5f5"
                            cx="32"
                            cy="33"
                            rx="32"
                            ry="7"
                          ></ellipse>
                          <g fill-rule="nonzero" stroke="#d9d9d9">
                            <path
                              d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
                            ></path>
                            <path
                              d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
                              fill="#fafafa"
                            ></path>
                          </g>
                        </g>
                      </svg>
                    </div>
                    <p style="color: #00000040; margin-bottom: 0px">No data</p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <!-- Holiday Update Modal -->
      <div
        class="modal custom-modal fade"
        id="holiday_update_modal"
        tabindex="-1"
        aria-labelledby="holidayUpdateModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-xl modal-dialog-centered">
          <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
              <h5 class="modal-title" id="holidayUpdateModalLabel">
                Leave Update
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref="holidayupdateclose"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body">
              <div class="card shadow-sm">
                <div class="card-body">
                  <div class="table-responsive">
                    <table
                      class="table table-bordered table-hover align-middle"
                    >
                      <thead class="table-light">
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>From</th>
                          <th>To</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(
                            user, index
                          ) in updateDetailsData.vacation_leave"
                          :key="user.id"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>{{ user.first_name + " " + user.last_name }}</td>
                          <td>{{ user.from }}</td>
                          <td>{{ user.to }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Holiday Update Modal -->
    </div>
    <!-- /Page Wrapper -->
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";
import { notification } from "ant-design-vue";
import { mapActions } from "vuex";
import { DateTime } from "luxon";

export default {
  data() {
    return {
      dashboardData: null,
      defaultAvatar: "avatar-01.jpg",
      today_active_data: null,
      todayAttendanceData: null,
    };
  },
  computed: {
    user() {
      let user = localStorage.getItem("user");
      if (user && user != null) {
        user = JSON.parse(user);
      }

      return user ? user : null;
    },
    today() {
      const today = moment();
      return today.format("dddd, DD MMMM YYYY");
    },
    punchInTime() {
      if (Array.isArray(this.today_active_data)) {
        const punchInRecord = this.today_active_data.find(
          (record) => record.punch_type === "punch-in"
        );

        if (punchInRecord) {
          return punchInRecord?.employee_attendances_details_time1 &&
            punchInRecord?.employee_attendances_details_time1 != null
            ? this.convertToLocalTime(
                punchInRecord.employee_attendances_details_time1
              )
            : "";
        }
      }
      return null;
    },
    punchOutTime() {
      if (!Array.isArray(this.today_active_data)) return null;

      const punchOutRecords = this.today_active_data
        .filter(
          (record) =>
            record.punch_type === "punch-out" &&
            record.punch_out_reason === "Final Punch Out" &&
            record.employee_attendances_details_time1
        )
        .sort(
          (a, b) =>
            new Date(a.employee_attendances_details_time1) -
            new Date(b.employee_attendances_details_time1)
        );

      const lastPunchOut = punchOutRecords[punchOutRecords.length - 1];

      return lastPunchOut
        ? this.convertToLocalTime(
            lastPunchOut.employee_attendances_details_time1
          )
        : null;
    },
    todayLabel() {
      return this.todayAttendanceData?.today_status
        ? this.todayAttendanceData?.today_status
        : [];
    },
    upcomingHolidays() {
      return this.dashboardData?.holidays ? this.dashboardData?.holidays : [];
    },
    remainLeaveCount() {
      return this.dashboardData?.remaining_leaves
        ? this.dashboardData?.remaining_leaves
        : 0;
    },
    leaveCount() {
      return this.dashboardData?.leaves_count
        ? this.dashboardData?.leaves_count
        : 0;
    },
    projects() {
      return this.dashboardData?.projects ? this.dashboardData?.projects : [];
    },
    tasks() {
      return this.dashboardData?.task ? this.dashboardData?.task : 0;
    },
    todayData() {
      return this.dashboardData?.today_data
        ? this.dashboardData?.today_data
        : [];
    },
    tomorrowData() {
      return this.dashboardData?.tomorrow_data
        ? this.dashboardData?.tomorrow_data
        : [];
    },
    requestData() {
      return this.dashboardData?.requests ? this.dashboardData?.requests : [];
    },
    nextSevenData() {
      return this.dashboardData?.next7days_data
        ? this.dashboardData?.next7days_data
        : [];
    },
    updateData() {
      return this.dashboardData?.updates ? this.dashboardData?.updates : [];
    },
    updateDetailsData() {
      return this.dashboardData?.updates_details
        ? this.dashboardData?.updates_details
        : [];
    },
  },
  methods: {
    ...mapActions(["fetchEmployeeAttendance"]),
    fetchData() {
      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      this.fetchEmployeeAttendance().then((response) => {
        if (response) {
          this.today_active_data = [...response.todayactivities].sort(
            (a, b) => new Date(a.created_at) - new Date(b.created_at)
          );
          this.todayAttendanceData = response;
        }
      });

      axios
        .get("/dashboard")
        .then((response) => {
          loader.hide();
          this.dashboardData = response?.data?.data;
          console.log(this.dashboardData);
        })
        .catch((error) => {
          loader.hide();
          if (
            error?.response?.status == 401 &&
            response?.data?.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          }

          if (error.response) {
            var response = error.response;

            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    convertToLocalTime(utcTime) {
      const utcDateTime = DateTime.fromFormat(utcTime, "yyyy-MM-dd HH:mm:ss");
      const istDateTime = utcDateTime.setZone(
        Intl.DateTimeFormat().resolvedOptions().timeZone
      );
      //const istDateTime = utcDateTime.setZone(process.env.VUE_APP_API_BASE_URL);
      const istTimeString = istDateTime.toLocaleString(DateTime.DATETIME_SHORT);

      return istTimeString;
    },
    getDateFromat(date) {
      return moment(date).format("ddd DD MMM YYYY");
    },
    redirectTo(route) {
      this.$router.push({ path: route }).catch((error) => {});
    },
    handleImageError() {
      this.user.avatar = `assets/img/profiles/${this.defaultAvatar}`;
    },
    getEmployeeAvatar(avatar) {
      return `${process.env.VUE_APP_IMAGE_BASE_URL}${avatar}`;
    },
  },
  mounted() {
    const hasPermissionChange = this?.$route?.params?.hasPermissionChange;

    if (hasPermissionChange) {
      notification.open({
        message: "Your permission has been change.",
        placement: "topRight",
        duration: process.env.VUE_APP_NOTIFICATION_DURATION,
        style: {
          background: process.env.VUE_APP_WARNING_COLOR,
        },
      });
    }
    this.fetchData();
  },
};
</script>

<style scoped>
.dash-card-content {
  color: #6c757d;
}

.dash-card-content.no-data-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 100%;
}

.status-badge {
  display: inline-block;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 4px;
  margin-left: 2px;
}

.status-badge.present {
  background: #e6f7f0;
  color: #0f9d58;
}

.status-badge.absent {
  background: #fdecea;
  color: #d93025;
}

.status-badge.leave {
  background: #fdecea;
  color: #d93025;
}

.status-badge.holiday {
  background: #fff4e5;
  color: #f29900;
}

.punch-time {
  font-size: 12px;
  color: #6c757d;
}
</style>
